import forge from "node-forge";
import { CONNECTION_SYMMETRIC_KEY } from "../../constants/methods";
import Client from "../../libs/Api/Client";
import { protoHandler } from "../../libs/proto";
import { randomString, stringToUint8Array } from "../../libs/utils";
import { ConnectionSecuringResponse } from "../../proto/ConnectionSecuring_pb";
import BaseHandler from "../BaseHandler";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID } from "../../constants/localstorage";
import Metrix from "../../libs/metrix";

const embeddedPublicKey: any = forge.pki.publicKeyFromPem(process.env.REACT_APP_EMBEDDED_PEM!);

export default class HandleConnectionSecuringResponse extends BaseHandler<ConnectionSecuringResponse> {
  handle() {
    const connectionSecuringResponse = this.response.toObject();

    const publicKey = forge.pki.publicKeyFromPem(connectionSecuringResponse.publicKey);
    const symmetricKey = randomString(connectionSecuringResponse.symmetricKeyLength);
    Client.instance.symmetricKey = symmetricKey;
    Client.instance.heartbeatInterval = connectionSecuringResponse.heartbeatInterval;
    Metrix.initialize({ uniqueDeviceId: getStorage(STORAGE_USER_ID) });

    let key = publicKey.encrypt(symmetricKey);
    let secureKey = "";
    while (key.length) {
      secureKey += embeddedPublicKey.encrypt(key.substr(0, connectionSecuringResponse.secondaryChunkSize));
      key = key.substr(connectionSecuringResponse.secondaryChunkSize);
    }

    protoHandler(
      CONNECTION_SYMMETRIC_KEY,
      {
        symmetricKey: stringToUint8Array(secureKey),
        version: 2,
      },
      { insecure: true }
    )
      .then()
      .catch(() => {
        console.error("SOCKET CLOSED FROM HandleConnectionSecuringResponse.ts handle");
        Client.instance.close();
      });
  }
}
